<template>
  <a-modal title="客户自费对账单" :width="1500" v-model="customerSingleible" footer="">
    <div class="table-page-search-wrapper">
      <a-form layout="inline" :form="form2">
        <a-row :gutter="24">
          <a-col :md="6" :sm="24">
            <a-form-item label="订单号" style="margin-left: 39px">
              <a-input v-model.trim="queryParam.orderNo" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="安装类别" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 30px">
              <a-select v-model="queryParam.installType" @change="installChange" :allowClear="true">
                <a-select-option v-for="type in installTypes" :key="type.dictValue">{{
                  type.dictLabel
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="订单类型" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 30px">
              <a-select v-model="queryParam.orderType" @change="getorderStatus" :allowClear="true">
                <a-select-option v-for="type in List" :key="type.orderTypeId">{{ type.typeName }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="订单子状态" style="margin-left: 13px">
              <a-select v-model="queryParam.orderSubStatus" :allowClear="true">
                <a-select-option v-for="type in order_substate" :key="type.dictValue">{{
                  type.dictLabel
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :md="6" :sm="24">
            <a-form-item label="客户姓名" style="margin-left: 26px">
              <a-input v-model.trim="queryParam.customerName" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="客户联系方式">
              <a-input v-model.trim="queryParam.customerMobile" />
            </a-form-item>
          </a-col>
          <a-col :md="12" :sm="24">
            <a-row :gutter="24" style="margin-left: 0px">
              <a-form-item label="客户地址" style="margin-left: 30px">
                <a-col :md="5" :sm="24">
                  <a-select v-model="queryParam.province" @change="getselect" :allowClear="true">
                    <a-select-option v-for="type in selectAllProvince" :key="type.provinceCode">{{
                      type.provinceName
                    }}</a-select-option>
                  </a-select>
                </a-col>
                <a-col :md="5" :sm="24">
                  <a-select v-model="queryParam.city" @change="getprovinceName" :allowClear="true">
                    <a-select-option v-for="type in selectCityName" :key="type.cityCode">{{
                      type.cityName
                    }}</a-select-option>
                  </a-select>
                </a-col>
                <a-col :md="5" :sm="24">
                  <a-select v-model="queryParam.area" :allowClear="true">
                    <a-select-option v-for="type in selectAreaName" :key="type.areaCode">{{
                      type.areaName
                    }}</a-select-option>
                  </a-select>
                </a-col>
                <a-col :md="9" :sm="24">
                  <a-input v-model.trim="queryParam.address" />
                </a-col>
              </a-form-item>
            </a-row>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :md="6" :sm="24">
            <a-form-item label="账单号" style="margin-left: 39px">
              <a-input v-model.trim="queryParam.statementNo" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="账单名" style="margin-left: 45px">
              <a-input v-model.trim="queryParam.statementName" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="师傅结算状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select v-model="queryParam.masterSettleStatus" :allowClear="true">
                <a-select-option v-for="type in settlement_status" :key="type.dictValue">{{
                  type.dictLabel
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="客户自费收款状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select v-model="queryParam.receiveMoneyStatus" :allowClear="true">
                <a-select-option v-for="type in receive_money_status" :key="type.dictValue">{{
                  type.dictLabel
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :md="6" :sm="24">
            <a-form-item label="品牌" style="margin-left: 55px">
              <a-select
                showSearch
                optionFilterProp="children"
                :filterOption="filterOption"
                v-model="queryParam.brand"
                :allowClear="true"
              >
                <a-select-option v-for="type in selectBrand" :key="type.brandId">{{ type.brandName }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="型号" style="margin-left: 60px">
              <a-select
                showSearch
                optionFilterProp="children"
                @change="changeModelName"
                :filterOption="filterOption"
                v-model="queryParam.model"
                :allowClear="true"
              >
                <a-select-option v-for="type in selectModel" :key="type.modelId">{{ type.modelName }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="24">
            <a-form-item label="购买渠道" style="margin-left: 30px">
              <a-select
                showSearch
                optionFilterProp="children"
                @change="changesourceName"
                :filterOption="filterOption"
                v-model="queryParam.buyChannel"
                :allowClear="true"
              >
                <a-select-option v-for="type in selectChannel" :key="type.channelId"
                  >{{ type.channelName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="客户自费收款时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-range-picker
                style="width: 100%"
                v-model="receiveMoney"
                :show-time="{
                  hideDisabledOptions: true,
                  defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                }"
                format="YYYY-MM-DD HH:mm:ss"
                :placeholder="['开始时间', '结束时间']"
                @change="onChangereceiveMoney"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <div v-if="Ifstatus">
          <a-row :gutter="24">
            <a-col :md="6" :sm="24">
              <a-form-item label="建单时间" style="margin-left: 26px">
                <a-range-picker
                  style="width: 100%"
                  v-model="createTime"
                  :show-time="{
                    hideDisabledOptions: true,
                    defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                  }"
                  format="YYYY-MM-DD HH:mm:ss"
                  :placeholder="['开始时间', '结束时间']"
                  @change="onChangecreateOrde"
                />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="订单完成时间">
                <a-range-picker
                  style="width: 100%"
                  v-model="completeTime"
                  :show-time="{
                    hideDisabledOptions: true,
                    defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                  }"
                  format="YYYY-MM-DD HH:mm:ss"
                  :placeholder="['开始时间', '结束时间']"
                  @change="onChangecompleteOrder"
                />
              </a-form-item>
            </a-col>
          </a-row>
        </div>

        <a-row>
          <a-col :span="1" :offset="11">
            <span v-if="Ifstatus == 0" style="cursor: pointer" @click="getMore"
              ><a-icon type="down-circle" theme="twoTone" style="fontsize: 24px"
            /></span>
            <span v-if="Ifstatus == 1" style="cursor: pointer" @click="hiddenMore"
              ><a-icon type="up-circle" theme="twoTone" style="fontsize: 24px"
            /></span>
          </a-col>
          <a-col :span="12" :style="{ textAlign: 'right' }">
            <a-button type="primary" htmlType="submit" @click="query">查询</a-button>
            <a-button style="margin-left: 8px" @click="empty()">清空</a-button>
            <a-button style="margin-left: 8px" type="primary" v-if="exportOrderCustomerStatement" @click="exportEnt()"
              >导出 Excel</a-button
            >
          </a-col>
        </a-row>
        <a-divider />
        <!---->
      </a-form>
    </div>
    <!--   江苏锁安科技有限公司 2020年2月对帐单  表头-->
    <a-row v-if="editList" style="margin-top: 30px">
      <a-col :span="21">
        <h1 style="text-align: center">{{ editList.majorStatementName }}</h1>
        <h4 style="text-align: center">市场负责人：{{ editList.marketPrincipal }}</h4>
      </a-col>
    </a-row>
    <!--    第一个单选框-->
    <a-row>
      <a-col :span="19">
        <div style="text-align: center; margin: 20px 0">
          <a-radio-group :options="plainOptions" @change="onChangeRadio1" />
        </div>
      </a-col>
      <a-col :span="5" :style="{ textAlign: 'right' }">
        <a-button
          type="primary"
          @click="reinsurancePolicy()"
          v-if="editTimeCustomerStatement"
          :loading="loading"
          style="margin-right: 20px"
          >提交
        </a-button>
        <a-button type="primary" @click="modifyDefaultTemplate()" v-if="editTimeCustomerStatement" :loading="loading">
          修改默认模版
        </a-button>
      </a-col>
    </a-row>
    <!--    第二个单选框-->
    <div>
      <div v-for="(item, i) in subStatements">
        <a-row>
          <a-col :span="19">
            <a-row>
              <a-col :span="3"> </a-col>
              <a-col :span="8">
                <span style="font-weight: bold; font-size: 20px; margin-right: 10px; line-height: 30px">{{
                  item.subStatementName
                }}</span>
                <span style="font-size: 16px; line-height: 30px">截止至{{ item.closingDate }}</span>
              </a-col>
              <a-col :span="13" style="margin-top: 5px">
                <a-checkbox @change="onChangeSettleComplete(i, item.subStatementId, $event)">
                  不显示已结算订单
                </a-checkbox>
                <a-checkbox @change="onChangeDeduction(i, item.subStatementId, $event)"> 显示扣款订单 </a-checkbox>
                <a-checkbox @change="onChangeLoss(i, item.subStatementId, $event)"> 显示倒挂订单 </a-checkbox>
              </a-col>
            </a-row>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="19" style="margin: 10px 0">
            <a-row>
              <a-col :span="5"> </a-col>
              <a-col :span="6">
                <span style="font-size: 14px; line-height: 30px; font-weight: 700">账单号：{{ item.statementNo }}</span>
              </a-col>
              <a-col :span="6">
                <span style="font-size: 14px; line-height: 30px; font-weight: 700"
                  >收款超时天数：{{ item.overDays }}</span
                >
              </a-col>
            </a-row>
          </a-col>
        </a-row>
        <div style="margin-bottom: 16px"></div>
        <!--        表格内容-->
        <a-table
          size="default"
          ref="table"
          rowKey="orderId"
          :columns="columns"
          :dataSource="item.orders"
          :pagination="false"
          bordered
          :scroll="{ x: 6500 }"
          :rowClassName="setClassName"
        >
          <template slot="money" slot-scope="text, record">
            <editable-cell
              :editable="editableArray[i]"
              :text="record.settleAmount"
              @finishEdit="finishEdit(i)"
              @change="onCellChange(record.orderId, item.subStatementId, $event)"
            />
          </template>
          <span slot="action" slot-scope="text, record" style="white-space: nowrap">
            <!--v-if="item.amountUpdateFlag==='2'" -->
            <a
              @click="confirmRevision(record.orderId, item.subStatementId)"
              v-if="
                (item.statementStatus === '3' || item.statementStatus === '5') &&
                  submitCustomerStatement &&
                  record.amountUpdateFlag === '2'
              "
              >确认修改</a
            >
            <a-divider type="vertical" v-if="select" />
            <a v-if="select" @click="orderdetailsView(record.orderId)">查看</a>
            <a-divider
              type="vertical"
              v-if="
                record.receiveMoneyStatusCode == 0 ||
                  (record.receiveMoneyStatusCode == 1 && singlesettlementCustomerStatement)
              "
            />
            <a
              v-if="
                record.receiveMoneyStatusCode == 0 ||
                  (record.receiveMoneyStatusCode == 1 && singlesettlementCustomerStatement)
              "
              @click="billCompleted(record.orderId, 2)"
            >
              收款</a
            >
            <a-divider
              type="vertical"
              v-if="
                (record.receiveMoneyStatusCode == 2 || record.receiveMoneyStatusCode == 3) &&
                  record.statementStatusCode != 6 &&
                  record.statementStatusCode != 7 &&
                  singlesettlementCustomerStatement
              "
            />
            <a
              v-if="
                (record.receiveMoneyStatusCode == 2 || record.receiveMoneyStatusCode == 3) &&
                  record.statementStatusCode != 6 &&
                  record.statementStatusCode != 7 &&
                  singlesettlementCustomerStatement
              "
              @click="refundButton(record.orderId, 2)"
            >
              退款</a
            >
            <a-divider type="vertical" v-if="removeCustomerStatement" />
            <a v-if="removeCustomerStatement" @click="remove(record)">移除</a>
            <a-divider type="vertical" v-if="remarkCustomerStatement" />
            <a v-if="remarkCustomerStatement" @click="remarkList(record)">备注</a>
          </span>
          <span slot="remark" slot-scope="text, record">
            <span v-if="record.remark">
              <span v-for="tab in record.remark.split('/$/')">
                <span>
                  {{ tab }}
                </span>
                <br />
              </span>
            </span>
          </span>
          <span slot="updateAmount" slot-scope="text, record">
            <a-popover title="修改备注">
              <template slot="content">
                <div style="overflow-y: auto; max-height: 450px; padding-right: 20px" v-if="record.orderUpdateRemark">
                  <span v-for="tab in record.orderUpdateRemark.split('/$/')"
                    ><span>{{ tab }}</span>
                    <br />
                  </span>
                </div>
              </template>
              <a type="primary">
                <span v-if="record.updateAmount > 0" class="classYellow">{{ record.updateAmount }}</span>
                <span v-else>{{ record.updateAmount }}</span>
              </a>
            </a-popover>
          </span>
          <span slot="masterSettleAmount" slot-scope="text, record">
            <span v-if="record.masterStatementFlag == 0">
              <a style="color: red">{{ record.masterSettleAmount }}</a>
            </span>
            <span v-else>
              <a>{{ record.masterSettleAmount }}</a>
            </span>
          </span>
        </a-table>
        <!--    最后字段第一行-->
        <a-row>
          <a-col :span="19" style="margin: 10px 0">
            <a-row>
              <a-col :span="5"> </a-col>
              <a-col :span="19" style="text-align: center">
                <span style="font-size: 14px; font-weight: 700"
                  >【企业】订单总金额：{{ item.customerTotalAmount }}元 结算总金额：{{ item.customerSettleAmount }}元
                </span>
                <span style="font-size: 14px; font-weight: 700" v-if="viewMasterPriceCustomerStatement"
                  >【师傅】订单总金额：{{ item.masterTotalAmount }}元 结算总金额：{{ item.masterSettleAmount }}元
                </span>
              </a-col>
            </a-row>
          </a-col>
        </a-row>
        <!--    最后字段第二行-->
        <a-row>
          <a-col :span="19" style="margin: 10px 0">
            <a-row>
              <a-col :span="5"> </a-col>
              <a-col :span="19" style="text-align: center">
                <span style="font-size: 14px; font-weight: 700; text-align: center"
                  ><span v-if="viewMasterPriceCustomerStatement"
                    >成本：{{ item.cost }}元 毛利：{{ item.grossProfit }}元</span
                  >
                  结算扣款：{{ item.deduction }}元 已退款金额：{{ item.alreadyRefundAmount }}元 订单总计：{{
                    item.orderNum
                  }}单
                </span>
              </a-col>
            </a-row>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="19" style="margin: 10px 0">
            <a-row>
              <a-col :span="5"> </a-col>
              <a-col :span="19" style="text-align: center">
                <span style="font-size: 14px; font-weight: 700; text-align: center"
                  >结算金额：{{ item.customerSettleAmount }}元 已结算金额：{{ item.alreadySettleAmount }}元
                  实际需结算：{{ item.needSettleAmount }}元 已退款金额：{{ item.alreadyRefundAmount }}元 订单总计：{{
                    item.orderNum
                  }}单
                </span>
              </a-col>
            </a-row>
          </a-col>
        </a-row>
        <!--    最后的按钮-->
        <a-row>
          <a-col :span="19" style="margin: 10px 0">
            <a-row>
              <a-col :span="3"> </a-col>
              <a-col :span="21" style="text-align: center; margin: 20px 0">
                <!--v-if="item.amountUpdateFlag==='2'"-->
                <a-button
                  type="primary"
                  v-if="(item.statementStatus == '3' || item.statementStatus == '5') && submitCustomerStatement"
                  @click="confirmAmount(item.subStatementId, 1)"
                  >确认修改</a-button
                >
                <a-button
                  type="primary"
                  style="margin-left: 8px"
                  v-if="
                    item.receiveMoneyStatusCode == 0 ||
                      (item.receiveMoneyStatusCode == 1 && singlesettlementCustomerStatement)
                  "
                  @click="billCompleted(item.subStatementId, 1)"
                  >收款完成</a-button
                >
                <a-button
                  type="primary"
                  style="margin-left: 8px"
                  v-if="
                    (item.receiveMoneyStatusCode == 2 || item.receiveMoneyStatusCode == 3) &&
                      item.statementStatusCode != 6 &&
                      item.statementStatusCode != 7 &&
                      singlesettlementCustomerStatement
                  "
                  @click="refundButton(item.subStatementId, 1)"
                  >退款</a-button
                >
                <a-button
                  type="primary"
                  style="margin-left: 8px"
                  v-if="(item.statementStatus == '0' || item.statementStatus == '3') && submitCustomerStatement"
                  @click="eaitStatement(i)"
                  >修改对账单</a-button
                >
                <a-button
                  type="primary"
                  style="margin-left: 8px"
                  @click="submitStatement(item.subStatementId)"
                  v-if="
                    (item.statementStatus == '0' || item.statementStatus == '3' || item.statementStatus == '5') &&
                      submitCustomerStatement
                  "
                  >提交对帐单</a-button
                >
                <a-button style="margin-left: 8px" @click="goone()" :hidden="!hasdisabled">返回</a-button>
              </a-col>
            </a-row>
          </a-col>
        </a-row>
      </div>
    </div>
    <div :hidden="hasdisabled" style="border-top: 1px solid #000000; margin-top: 20px; padding-top: 10px">
      <!--    最后字段第一行-->
      <a-row v-if="editList">
        <a-col :span="19" style="margin: 10px 0">
          <a-row>
            <a-col :span="5"> </a-col>
            <a-col :span="19" style="text-align: center">
              <span style="font-size: 14px; font-weight: 700"
                >【企业】订单总金额：{{ editList.enterpriseTotalAmount }}元 结算总金额：{{
                  editList.enterpriseSettleAmount
                }}元
              </span>
              <span style="font-size: 14px; font-weight: 700"
                >【师傅】订单总金额：{{ editList.masterTotalAmount }}元 结算总金额：{{ editList.masterSettleAmount }}元
              </span>
            </a-col>
          </a-row>
        </a-col>
      </a-row>
      <!--    最后字段第二行-->
      <a-row v-if="editList">
        <a-col :span="19" style="margin: 10px 0">
          <a-row>
            <a-col :span="5"> </a-col>
            <a-col :span="19" style="text-align: center">
              <span style="font-size: 14px; font-weight: 700; text-align: center"
                >成本：{{ editList.cost }}元 毛利：{{ editList.grossProfit }}元 结算扣款：{{ editList.deduction }}元
                已退款金额：{{ editList.cost }}元 订单总计：{{ editList.alreadySettleAmount }}单
              </span>
            </a-col>
          </a-row>
        </a-col>
      </a-row>
      <!--    最后的按钮-->
      <a-row>
        <a-col :span="19" style="margin: 10px 0">
          <a-row>
            <a-col :span="3"> </a-col>
            <a-col :span="21" style="text-align: center; margin: 20px 0">
              <a-button
                type="primary"
                style="margin-left: 8px"
                v-if="amountUpdateFlag === '2' && submitCustomerStatement && modificationConfirm"
                @click="confirmAmount(0, 0)"
                >全部确认修改
              </a-button>
              <a-button
                type="primary"
                style="margin-left: 8px"
                v-if="completedSettlement && singlesettlementCustomerStatement"
                @click="billCompleted(0, 0)"
                >全部收款完成</a-button
              >
              <a-button
                type="primary"
                style="margin-left: 8px"
                v-if="
                  (this.editList.receiveMoneyStatusCode == 2 || this.editList.receiveMoneyStatusCode == 3) &&
                    this.editList.statementStatusCode != 6 &&
                    this.editList.statementStatusCode != 7 &&
                    singlesettlementCustomerStatement
                "
                @click="refundButton(0, 0)"
                >全部退款</a-button
              >
              <a-button
                type="primary"
                style="margin-left: 8px"
                @click="submitStatementall"
                v-if="submitCustomerStatement && statementSubmit"
                >全部提交对帐单</a-button
              >
              <a-button style="margin-left: 8px" @click="goone()">返回</a-button>
            </a-col>
          </a-row>
        </a-col>
      </a-row>
    </div>
    <a-modal title="备注" style="top: 20px" :width="900" v-model="remarkible" @ok="remarkconfirmOk">
      <a-form :form="form">
        <div>
          <a-form-item v-if="remarkrows.length > 0" :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注信息">
            <div v-for="type in remarkrows" :key="type.remarkId">
              <span style="margin: 0 30px"> {{ type.remark }}</span>
              <span style="margin: 0 10px"> {{ type.createBy }}</span>
              <span> {{ type.createTime }}</span>
            </div>
          </a-form-item>
        </div>
        <a-form-item style="display: none">
          <a-input v-decorator="['enterpriseId']" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="新增备注">
          <a-input v-decorator="['remark']" />
        </a-form-item>
      </a-form>
    </a-modal>
    <!--    结算完成的弹框-->
    <a-modal
      title="收款"
      style="top: 20px"
      :width="800"
      v-model="Settlementible"
      :confirmLoading="confirmLoading"
      @ok="EnterpriseOk"
      @cancel="handleCancel"
    >
      <a-form :form="formSettlement">
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="需支付">
          <a-input v-decorator="['needpayAmount']" disabled />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="实际支付">
          <a-input-number
            v-decorator="[
              'amount',
              {
                rules: [{ required: true, message: '请填写实际支付金额!' }]
              }
            ]"
            :max="this.formSettlement.getFieldValue('needpayAmount')"
            @change="amountModify"
            style="width: 100%"
          />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="未支付">
          <a-input v-decorator="['Unpaid']" disabled="disabled" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="支付方式">
          <a-select
            v-decorator="[
              'payMethod',
              {
                rules: [{ required: true, message: '请选择支付方式!' }]
              }
            ]"
          >
            <a-select-option v-for="type in pay_method" :key="type.dictValue">{{ type.dictLabel }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注">
          <a-input
            type="textarea"
            v-decorator="[
              'remark',
              {
                rules: [
                  {
                    required: this.formSettlement.getFieldValue('Unpaid') > 0 ? true : false,
                    message: '请输入备注信息!'
                  }
                ]
              }
            ]"
          />
        </a-form-item>
      </a-form>
    </a-modal>
    <!--    移除的弹框提醒-->
    <!--    移除对账单确定按钮-->
    <a-modal
      title="移除"
      style="top: 20px"
      :width="800"
      v-model="removeible"
      :confirmLoading="confirmLoading"
      @ok="confirmOk"
      @cancel="confirmCancel"
    >
      <p>确定移除该条对账单吗？</p>
    </a-modal>
    <!--    // 退款-->
    <a-modal
      title="退款"
      style="top: 20px"
      :width="800"
      v-model="refundible"
      :confirmLoading="confirmLoading"
      @ok="refundOk"
      @cancel="refundCancel"
    >
      <a-form :form="refundform">
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="实际收款">
          <a-input v-decorator="['realReceipts']" disabled />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="退款">
          <a-input-number
            v-decorator="[
              'amount',
              {
                rules: [{ required: true, message: '请输入退款金额!' }]
              }
            ]"
            :max="this.refundform.getFieldValue('realReceipts')"
            @change="amountModify"
            style="width: 100%"
          />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="余额">
          <a-input v-decorator="['balance']" disabled />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="支付方式">
          <a-select
            v-decorator="[
              'payMethod',
              {
                rules: [{ required: true, message: '请选择支付方式!' }]
              }
            ]"
          >
            <a-select-option v-for="type in pay_method" :key="type.dictValue">{{ type.dictLabel }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注">
          <a-input type="textarea" v-decorator="['remark']" />
        </a-form-item>
      </a-form>
    </a-modal>
    <a-modal title="修改结算金额" style="top: 20px" :width="800" v-model="amountModifyible" footer="">
      <a-form :form="amountModifyform">
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="结算金额">
          <a-input v-decorator="['oldAmount']" disabled />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="修改后金额">
          <a-input
            v-decorator="[
              'newAmount',
              {
                rules: [{ required: true, message: '请输入修改金额!' }]
              }
            ]"
            @change="newAmountChange"
          />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="反馈">
          <div v-for="(type, index) in amountModifyremark" :key="index">{{ type }}</div>
          <a-input type="textarea" v-decorator="['remark']" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" style="text-align: center">
          <!--{{this.amountModifyId}}-->
          <a-button type="primary" style="margin-left: 8px" :disabled="disableOK" @click="confirmAmount(2, 2)"
            >确定
          </a-button>
          <a-button type="primary" style="margin-left: 8px" @click="amountModifyOk">修改 </a-button>
          <a-button type="primary" style="margin-left: 8px" @click="amountModifyCancel">取消 </a-button>
        </a-form-item>
      </a-form>
    </a-modal>
    <!-- 使用弹框组件-->
    <Enterprise-modal ref="modal" @ok="handleOk" />
    <modify-default-template-model ref="modify"></modify-default-template-model>
    <customer-submit-model ref="enterprisesubmit" @ok="refreshOrder"></customer-submit-model>
    <edit-order-model v-if="$store.state.user_type == 1" ref="editorder"></edit-order-model>
    <edit-order-model1 v-else ref="editorder"></edit-order-model1>
  </a-modal>
</template>
<script>
import { ACCESS_TOKEN } from '@/store/mutation-types'
import moment from 'moment'

import customerSubmitModel from '../modules/customerSubmitModel.vue'
import { STable } from '@/components'
import modifyDefaultTemplateModel from '../modules/modifyDefaultTemplateModel.vue'
import {
  getSeparateList,
  getupdateExpectDate,
  getdetailFilte,
  getQueryNeedPay,
  getEnterpriseSettleList,
  removeList,
  getStatementRreceiver,
  getTemplate,
  getAlreadyPay,
  getRefundList,
  getupdateSettleAmount,
  getconfirmAmount,
  getexportList,
  getsubDetailExport,
  gettoBeConfirmedAmount
} from '@/api/finance/customerSingle'
import { getselectSource, getselectChannel } from '@/api/order/NewlyaddedOrderList'
import {
  getList,
  getselectAllProvince,
  getselectCityName,
  getselectAreaName,
  getmarketPrincipal,
  getSelectBrand,
  getOrderDetail,
  getSelectModel,
  getfindByDeptId,
  getfinddictAll
} from '@/api/order/orderList'
import { getEditList } from '@/api/finance/customerStatementsList'
import { getDataTemplate } from '@/api/finance/enterpriseSingle'
import EnterpriseModal from '../modules/EnterpriseModal.vue'
import { checkPermission } from '@/utils/permissions'
import { getDictMap } from '../../../utils/dict'
import { getremarkList, saveremarkList } from '@/api/finance/enterpriseBill'
const EditableCell = {
  template: `
      <div class="editable-cell">
        <div v-if="editable" class="editable-cell-input-wrapper">
          <a-input :value="value" @change="handleChange" @pressEnter="check" />
          <a-icon
            type="check"
            class="editable-cell-icon-check"
            @click="check"
          />
        </div>
        <div v-else class="editable-cell-text-wrapper">
          {{ value || ' ' }}

        </div>
      </div>
    `,
  props: {
    text: String,
    editable: Boolean
  },
  data() {
    return {
      value: this.text,
      editable: this.editable
    }
  },
  methods: {
    handleChange(e) {
      const value = e.target.value
      this.value = value
    },
    check() {
      this.editable = false
      this.$emit('change', this.value)
      this.$emit('finishEdit')
    },
    edit() {
      this.editable = true
    }
  }
}
const options = [
  { label: '不显示已结算订单', value: 'notShowSettleComplete' },
  { label: '只显示扣款订单', value: 'showDeduction' },
  { label: '只显示倒挂订单', value: 'showLoss' }
]
export default {
  name: 'customerSingle',
  components: {
    STable,
    // 注册弹框组件
    EnterpriseModal,
    EditableCell,
    modifyDefaultTemplateModel,
    customerSubmitModel,
    editOrderModel: () => import('@/views/order/modules/editOrderModel'),
    editOrderModel1: () => import('@/views/order/modules/editOrderModel1')
  },
  data() {
    return {
      editableArray: new Array(100).fill(false),
      customerSingleible: false,
      editable: false,
      form2: this.$form.createForm(this),
      refundform: this.$form.createForm(this),
      formSettlement: this.$form.createForm(this),
      amountModifyform: this.$form.createForm(this),
      refundible: false,
      realReceipts: '',
      refund: '',
      refundid: '',
      amountUpdateFlag: '',
      createTime: '',
      completeTime: '',
      headers: {
        token: Vue.ls.get(ACCESS_TOKEN)
      },
      // 提交对账单
      subStatementsId: [],
      // 移除按钮
      removeible: false,
      removeLoading: false,
      orderId: '',
      // 备注
      remark: '',
      // 保存账单的id 2
      settleTargetId: '',
      receiveMoney: '',
      // 保存子账单的id的 1
      statementId: '',
      // 支付方式
      payMethod: '',
      // <!--    操作栏结算完成-->
      needpayAmount: '',
      actualpayAmount: '',
      // <!--    结算完成的弹框-->
      Settlementible: false,
      confirmLoading: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      //分单提交 需要的值
      separateMethod: '',
      // 编辑带过来的数据
      editList: '',
      subStatements: [],
      loading: false,
      form: this.$form.createForm(this),
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: '序号',
          dataIndex: 'rowNum',
          align: 'center'
        },
        {
          title: '操作栏',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // post的返回值
      reslist: '',
      remarkible: false,
      options,
      value1: 'installType',
      value2: '不显示已结算订单',
      // 字典为pay_method
      installTypes: [],
      pay_method: [],
      order_substate: [],
      List: [],
      // 省
      selectAllProvince: [],
      // 市
      selectCityName: [],
      // 区
      selectAreaName: [],
      selectSource: [],
      selectChannel: [],
      selectCombox: [],
      selectBrand: [],
      selectModel: [],
      settlement_status: [],
      receive_money_status: [],
      Ifstatus: 0,
      // 字典为分单方式
      plainOptions: [],
      removeCustomerStatement: checkPermission('removeCustomerStatement'),
      submitCustomerStatement: checkPermission('submitCustomerStatement'),
      exportOrderCustomerStatement: checkPermission('exportOrderCustomerStatement'),
      remarkCustomerStatement: checkPermission('remarkCustomerStatement'),
      editTimeCustomerStatement: checkPermission('editTimeCustomerStatement'),
      // 查看师傅金额
      viewMasterPriceCustomerStatement: checkPermission('viewMasterPriceCustomerStatement'),
      singlesettlementCustomerStatement: checkPermission('singlesettlementCustomerStatement'),
      select: checkPermission('order:list:select'),
      editstatementId: '',
      statementtType: '',
      refundtype: '',
      remarkrows: [],
      recordorderId: '',
      amountModifyId: '',
      subStatementId: '',
      amountModifyible: false,
      amountModifyremark: [],
      erprisesubmitlist: '',
      disableOK: false,
      modificationConfirm: '',
      statementSubmit: '',
      completedSettlement: ''
    }
  },
  filters: {},
  // 下拉框的选项
  async created() {},
  // 计算选中的数据条数
  computed: {
    Unpaid() {
      let Unpaidnum = this.needpayAmount - this.actualpayAmount
      return Unpaidnum
    },
    balance() {
      let Unpaidnum = this.realReceipts - this.refund
      return Unpaidnum
    },
    hasdisabled() {
      if (this.subStatement) {
        if (this.subStatements.length > 1) {
          return false
        } else {
          return true
        }
      }
    }
  },
  methods: {
    SetOptionTitle() {
      var selects = document.getElementsByTagName('select')
      if (selects.length > 0) {
        for (var i = 0; i < selects.length; i++) {
          var options = selects[i].options
          if (selects[i].options.length > 0) {
            for (var j = 0; j < options.length; j++) {
              if (options[j].title == '') options[j].title = options[j].text
            }
          }
        }
      }
    },
    onChangeSettleComplete(index, id, e) {
      this.queryParam.statementId = this.editstatementId
      this.queryParam.subStatementId = id
      this.subStatements[index].notShowSettleComplete = e.target.checked
      if (e.target.checked) {
        this.queryParam.notShowSettleComplete = 1
      } else {
        this.queryParam.notShowSettleComplete = ''
      }
      getdetailFilte(this.queryParam).then(res => {
        if (res.code === 0) {
          //console.log(res)
          if (res.data.orders) {
            this.subStatements[index].orders = res.data.orders
          } else {
            this.subStatements[index].orders = []
          }
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    onChangeDeduction(index, id, e) {
      this.queryParam.statementId = this.editstatementId
      this.queryParam.subStatementId = id
      this.subStatements[index].showDeduction = e.target.checked
      if (e.target.checked) {
        this.queryParam.showDeduction = 1
      } else {
        this.queryParam.showDeduction = ''
      }
      getdetailFilte(this.queryParam).then(res => {
        if (res.code === 0) {
          // console.log(res)
          if (res.data.orders) {
            this.subStatements[index].orders = res.data.orders
          } else {
            this.subStatements[index].orders = []
          }
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    onChangeLoss(index, id, e) {
      this.queryParam.statementId = this.editstatementId
      this.queryParam.subStatementId = id
      this.subStatements[index].showLoss = e.target.checked
      //console.log(`checked = ${e.target.checked}`);
      if (e.target.checked) {
        this.queryParam.showLoss = 1
      } else {
        this.queryParam.showLoss = ''
      }
      getdetailFilte(this.queryParam).then(res => {
        if (res.code === 0) {
          //console.log(res)
          if (res.data.orders) {
            this.subStatements[index].orders = res.data.orders
          } else {
            this.subStatements[index].orders = []
          }
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    refreshOrder() {
      this.query()
      this.$emit('ok')
    },
    async showcreated() {
      this.empty()
      let dictTypes = ['install_type', 'pay_method', 'order_substate', 'settlement_status', 'receive_money_status']
      getfinddictAll({ dictTypes: dictTypes.join() }).then(res => {
        this.installTypes = res.install_type
        this.order_substate = res.order_substate
        this.settlement_status = res.settlement_status
        this.pay_method = res.pay_method
        this.receive_money_status = res.receive_money_status
      })
      // 字典为分单方式
      this.plainOptions = []
      this.restaurantOperTypeMap = await getDictMap('seperate_order_method')
      this.restaurantOperTypeMap.forEach((value, key) => {
        this.plainOptions.push({ value: key, label: value })
      })
      this.selectChannel = []
      // 查询信息来源下拉框
      await getselectChannel().then(res => {
        if (res.code === 0) {
          // console.log(res)
          this.selectChannel = res.data
        } else {
          this.$message.error(res.msg)
        }
      })
      this.selectSource = []
      // 查询信息来源下拉框
      await getselectSource().then(res => {
        if (res.code === 0) {
          // console.log(res)
          this.selectSource = res.data
        } else {
          this.$message.error(res.msg)
        }
      })
      this.selectBrand = []
      await getSelectBrand().then(res => {
        if (res.code === 0) {
          this.selectBrand = res.data
        } else {
          this.$message.error(res.msg)
        }
      })
      this.selectModel = []
      await getSelectModel().then(res => {
        if (res.code === 0) {
          this.selectModel = res.data
        } else {
          this.$message.error(res.msg)
        }
      })
      await getselectAllProvince().then(res => {
        if (res.code === 0) {
          // console.log(res)
          this.selectAllProvince = res.rows
        } else {
          this.$message.error(res.msg)
        }
      })

      this.revisiondisabled()
    },
    empty() {
      this.queryParam = {}
      this.completeTime = ''
      this.createTime = ''
      this.receiveMoney = ''
      this.form2.resetFields()
    },
    moment,
    setClassName(record) {
      // console.log(record)
      if (record.temporarilySettle == 1) {
        return 'clickRowStyle'
      } else if (record.isLossOrder == 1) {
        return 'clickRowStyleOrange'
      }
    },
    newAmountChange() {
      this.disableOK = true
    },
    showcustomerSingle(id) {
      this.showcreated()
      ;(this.editableArray = new Array(100).fill(false)), (this.customerSingleible = true)
      this.editstatementId = id
      // this.editstatementId=this.$route.params.statementId
      getDataTemplate({ statementId: this.editstatementId, statementOwnerType: 1, statementType: 0 }).then(res => {
        if (res.code === 0) {
          // console.log(res)
          for (let col of res.data) {
            col['align'] = 'center'

            if (col.dataIndex == 'settleAmount') col['scopedSlots'] = { customRender: 'money' }
          }
          for (let col of res.data) {
            if (col.dataIndex == 'remark') col['scopedSlots'] = { customRender: 'remark' }
          }
          for (let col of res.data) {
            if (col.dataIndex == 'updateAmount') col['scopedSlots'] = { customRender: 'updateAmount' }
          }
          for (let col of res.data) {
            if (col.dataIndex == 'masterSettleAmount') col['scopedSlots'] = { customRender: 'masterSettleAmount' }
          }
          if (!this.viewMasterPriceCustomerStatement) {
            for (let col of res.data) {
              if (
                col.dataIndex == 'masterSettleStatus' ||
                col.dataIndex == 'masterTotalAmount' ||
                col.dataIndex == 'masterSettleAmount' ||
                col.dataIndex == 'cost'
              )
                col['className'] = 'notshow'
            }
          }
          ;(this.columns = [
            {
              title: '序号',
              dataIndex: 'rowNum',
              align: 'center'
            },
            {
              title: '操作栏',

              dataIndex: 'action',
              scopedSlots: { customRender: 'action' }
            }
          ]),
            (this.columns = [...this.columns, ...res.data])
        } else {
          this.$message.error(res.msg)
        }
      })
      getEditList({ statementId: this.editstatementId }).then(res => {
        if (res.code === 0) {
          this.editList = res.data
          if (this.editList) {
            this.subStatements = this.editList.subStatements

            if (this.editList.subStatement) {
              this.editList.subStatements.forEach(tab => {
                if (tab.statementStatus == 3 || tab.statementStatus == 5) {
                  this.modificationConfirm = true
                } else {
                  this.modificationConfirm = false
                }
              })
              this.editList.subStatements.forEach(tab => {
                if (tab.statementStatus == 3 || tab.statementStatus == 0 || tab.statementStatus == 5) {
                  this.statementSubmit = true
                } else {
                  this.statementSubmit = false
                }
              })
              this.editList.subStatements.forEach(tab => {
                if (tab.statementStatus == 1 || tab.statementStatus == 0) {
                  this.completedSettlement = true
                } else {
                  this.completedSettlement = false
                }
              })
            }
          }
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    exportEnt() {
      this.queryParam.statementId = this.editstatementId
      var str = process.env.VUE_APP_API_BASE_URL + '/finance/customerStatement/detailExport?pageNum=1&pageSize=10'
      for (let i in this.queryParam) {
        if (this.queryParam[i] != undefined) {
          str = str + '&' + i + '=' + this.queryParam[i]
        }
      }
      str = str + '&token=' + this.headers.token
      console.log(str)
      window.open(str)
      // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
      // var date = new Date()
      // var Y = date.getFullYear()
      // var M = ((date.getMonth() + 1) < 10) ? ('0' + (date.getMonth() + 1)) : ((date.getMonth() + 1))
      // var D = (date.getDate() < 10) ? ('0' + date.getDate()) : (date.getDate())
      // var h = (date.getHours() < 10) ? ('0' + date.getHours()) : (date.getHours())
      // var m = (date.getMinutes() < 10) ? ('0' + date.getMinutes()) : (date.getMinutes())
      // var s = (date.getSeconds() < 10) ? ('0' + date.getSeconds()) : (date.getSeconds())
      // var ms = ''
      // if (date.getMilliseconds() < 10) {
      //   ms = '00' + date.getMilliseconds()
      // } else if (date.getMilliseconds() < 100) {
      //   ms = '0' + date.getMilliseconds()
      // } else {
      //   ms = date.getMilliseconds()
      // }
      //
      // getsubDetailExport(this.queryParam).then(res => {
      //   const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' })
      //   const a = document.createElement('a')
      //   // 生成文件路径
      //   let href = window.URL.createObjectURL(blob)
      //   a.href = href
      //   let fileName = Y + M + D + h + m + s + ms + '企业导出对账单详情（子对账单详情）'
      //   // 文件名中有中文 则对文件名进行转码
      //   a.download = decodeURIComponent(fileName)
      //   // 利用a标签做下载
      //   document.body.appendChild(a)
      //   a.click()
      //   document.body.removeChild(a)
      //   window.URL.revokeObjectURL(href)
      // })
    },
    onChangereceiveMoney(date, dateString) {
      this.queryParam.receiveMoneyTimeBegin = dateString[0]
      this.queryParam.receiveMoneyTimeEnd = dateString[1]
    },
    refreshEditList() {
      getEditList({ statementId: this.editstatementId }).then(res => {
        if (res.code === 0) {
          this.editList = res.data
          if (this.editList) {
            this.subStatements = this.editList.subStatements
          }
        } else {
          this.$message.error(res.msg)
        }
      })
      this.$emit('ok')
      this.$message.success('操作成功')
    },
    // 更多、隐藏
    getMore() {
      this.Ifstatus = 1
    },
    hiddenMore() {
      this.Ifstatus = 0
    },
    confirmAmount(id, type) {
      this.amountModifyible = false
      if (type == 1) {
        getconfirmAmount({ statementId: id, statementType: type }).then(res => {
          if (res.code === 0) {
            this.refreshEditList()
          } else {
            this.$message.error(res.msg)
          }
        })
      }
      if (type == 2 && id == 2) {
        getconfirmAmount({ statementId: this.amountModifyId, statementType: type }).then(res => {
          if (res.code === 0) {
            this.refreshEditList()
          } else {
            this.$message.error(res.msg)
          }
        })
      }
      if (id == 0 && type == 0) {
        getconfirmAmount({ statementId: this.editstatementId, statementType: type }).then(res => {
          if (res.code === 0) {
            this.refreshEditList()
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    confirmRevision(id, subStatementId) {
      this.amountModifyId = id
      this.subStatementId = subStatementId
      this.amountModifyform.resetFields()
      this.amountModifyible = true
      this.disableOK = false
      gettoBeConfirmedAmount({ orderId: id }).then(res => {
        if (res.code === 0) {
          setTimeout(() => {
            this.amountModifyform.setFieldsValue({
              oldAmount: res.data.oldAmount,
              newAmount: res.data.newAmount
            })
          }, 100)
          this.amountModifyremark = res.data.remark
          // this.realReceipts =res.data
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    amountModifyOk() {
      this.amountModifyform.validateFields((err, values) => {
        values.majorStatementId = this.editstatementId
        values.orderId = this.amountModifyId
        values.subStatementId = this.subStatementId
        if (!err) {
          getupdateSettleAmount(values).then(res => {
            if (res.code === 0) {
              this.refreshEditList()
              this.amountModifyible = false
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      })
    },
    amountModifyCancel() {
      this.amountModifyible = false
    },
    eaitStatement(index) {
      this.editableArray[index] = true
      this.editableArray = _.cloneDeep(this.editableArray)
    },
    finishEdit(index) {
      this.editableArray[index] = false
      this.editableArray = _.cloneDeep(this.editableArray)
      console.log('finish edit')
    },
    onCellChange(key, dataIndex, value) {
      console.log(key + ',dataIndex: ' + dataIndex + ',value:' + value)
      getupdateSettleAmount({
        majorStatementId: this.editstatementId,
        orderId: key,
        subStatementId: dataIndex,
        newAmount: value
      }).then(res => {
        if (res.code === 0) {
          this.refreshEditList()
        } else {
          this.$message.error(res.msg)
        }
      })
      // const dataSource = [...this.dataSource];
      // const target = dataSource.find(item => item.key === key);
      // if (target) {
      //   target[dataIndex] = value;
      //   this.dataSource = dataSource;
      // }
    },
    remarkList(record) {
      this.form.resetFields()
      this.remarkrows = []
      this.recordorderId = ''
      this.remarkible = true
      this.recordorderId = record.orderId
      getremarkList({ billRemarkType: 3, orderId: record.orderId }).then(res => {
        if (res.code === 0) {
          this.refreshEditList()
          this.remarkrows = res.rows
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    remarkconfirmOk() {
      this.remarkible = false
      this.form.validateFields((err, values) => {
        values.billRemarkType = 3
        values.orderId = this.recordorderId
        if (!err) {
          saveremarkList(values).then(res => {
            if (res.code === 0) {
              this.refreshEditList()
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      })
    },
    // 计算未支付值
    amountModify(e) {
      let realReceipts = this.refundform.getFieldValue('realReceipts')
      this.refundform.setFieldsValue({
        balance: realReceipts - 0 - e
      })
      let needpayAmount = this.formSettlement.getFieldValue('needpayAmount')
      this.formSettlement.setFieldsValue({
        Unpaid: needpayAmount - 0 - e
      })
    },
    orderdetailsView(orderId) {
      this.$nextTick(() => {
        this.$refs.editorder.showeditOrder(orderId, '', 0)
      })
    },
    query() {
      this.queryParam.statementId = this.editstatementId
      getEditList(this.queryParam).then(res => {
        if (res.code === 0) {
          this.editList = res.data
          if (this.editList) {
            this.subStatements = this.editList.subStatements
          }
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    onChangecreateOrde(date, dateString) {
      this.queryParam.createOrderTimeBegin = dateString[0]
      this.queryParam.createOrderTimeEnd = dateString[1]
    },
    onChangecompleteOrder(date, dateString) {
      this.queryParam.orderCompleteTimeBegin = dateString[0]
      this.queryParam.orderCompleteTimeEnd = dateString[1]
    },
    // 市
    getselect(e) {
      console.log(e)
      getselectCityName({ provinceCode: e }).then(res => {
        if (res.code === 0) {
          console.log(res)
          this.selectCityName = res.rows
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 区
    getprovinceName(e) {
      getselectAreaName({ cityCode: e }).then(res => {
        if (res.code === 0) {
          console.log(res)
          this.selectAreaName = res.rows
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    installChange9(e) {
      this.queryParam.orderType = e
    },
    getorderStatus(val) {
      if (val) {
        this.$set(this.queryParam, this.queryParam.orderType, val.value)
      } else {
        this.$set(this.queryParam, this.queryParam.orderType, '')
      }
    },
    async installChange(e) {
      this.form2.setFieldsValue({
        orderType9: ''
      })
      // this.queryParam.orderType=undefined
      this.List = []
      await getList(e).then(res => {
        if (res.code === 0) {
          this.List = res.rows
          // console.log(res.rows)
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 退款
    refundButton(id, type) {
      this.refundtype = type
      this.refundform.resetFields()
      this.refundible = true
      if (type == 0) {
        this.refundid = this.editstatementId
        getAlreadyPay({ targetType: type, targetId: this.refundid }).then(res => {
          if (res.code === 0) {
            setTimeout(() => {
              this.refundform.setFieldsValue({
                realReceipts: res.data
              })
            }, 100)
            // this.realReceipts =res.data
            // console.log(res)
          } else {
            this.$message.error(res.msg)
          }
        })
      } else {
        this.refundid = id
        getAlreadyPay({ targetType: type, targetId: id }).then(res => {
          if (res.code === 0) {
            setTimeout(() => {
              this.refundform.setFieldsValue({
                realReceipts: res.data
              })
            }, 100)
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    // 确定时调用的方法
    refundOk() {
      this.refundform.validateFields((err, values) => {
        values.refundTargetId = this.refundid
        values.refundTargetType = this.refundtype
        // console.log(values)
        if (!err) {
          this.refundible = false
          this.confirmLoading = false
          getRefundList(values).then(res => {
            if (res.code === 0) {
              this.refreshEditList()
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      })
      // console.log(this.payMethod,this.refundid)
      this.realReceipts = ''
      this.payMethod = ''
      this.remark = ''
    },
    // 取消时调用的方法
    refundCancel() {
      this.refundible = false
      // this.$router.push({name:'enterpriseStatement'})
    },

    revisiondisabled() {
      this.subStatements.forEach(item => {
        this.amountUpdateFlag = item.amountUpdateFlag
      })
    },
    // 修改默认模板
    modifyDefaultTemplate() {
      getTemplate({ enterpriseId: this.editList.enterpriseId }).then(res => {
        if (res.code === 0) {
          console.log(res.data)
          this.$refs.modify.showmodify(res.data)
          // this.$router.push({name:'modifyDefaultTemplate',params:{
          //     reslist:res.data}})
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    goone() {
      this.customerSingleible = false
    },

    // 提交对账单
    submitStatement(id, subStatementName) {
      this.subStatementsId = []
      this.subStatementsId.push(id)
      getStatementRreceiver({ enterpriseId: this.editList.enterpriseId }).then(res => {
        if (res.code === 0) {
          console.log(res.data)
          this.erprisesubmitlist = res.data
          this.erprisesubmitlist.subStatementName = subStatementName
          this.erprisesubmitlist.subStatementIds = this.subStatementsId
          this.erprisesubmitlist.majorStatementName = this.editList.majorStatementName
          this.erprisesubmitlist.majorStatementId = this.editList.majorStatementId
          this.$refs.enterprisesubmit.showenterprisesubmit(this.erprisesubmitlist)
          // this.$router.push({name:'customerSubmit',params:{
          //     majorStatementId:this.editList.majorStatementId,
          //     subStatementIds:this. subStatementsId
          //   }})
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    billCompleted(id, type) {
      this.formSettlement.resetFields()
      // console.log(this.editList)
      // console.log(id)
      this.statementtType = type
      this.Settlementible = true
      if (type == 0) {
        this.settleTargetId = this.editstatementId
        getQueryNeedPay({ targetType: type, targetId: this.settleTargetId }).then(res => {
          if (res.code === 0) {
            setTimeout(() => {
              this.formSettlement.setFieldsValue({
                needpayAmount: res.data
              })
            }, 100)
          } else {
            this.$message.error(res.msg)
          }
        })
      } else {
        this.settleTargetId = id
        getQueryNeedPay({ targetType: type, targetId: this.settleTargetId }).then(res => {
          if (res.code === 0) {
            setTimeout(() => {
              this.formSettlement.setFieldsValue({
                needpayAmount: res.data
              })
            }, 100)
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    // 确定时调用的方法
    EnterpriseOk() {
      this.formSettlement.validateFields((err, values) => {
        values.settleTargetType = this.statementtType
        values.settleTargetId = this.settleTargetId
        // console.log(values)
        if (!err) {
          this.Settlementible = false
          this.confirmLoading = false
          getEnterpriseSettleList(values).then(res => {
            if (res.code === 0) {
              this.refreshEditList()
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      })
      this.actualpayAmount = ''
      this.payMethod = ''
      this.remark = ''
    },
    // 取消时调用的方法
    handleCancel() {
      this.Enterprisevisible = false
      // this.$router.push({name:'enterpriseStatement'})
    },
    // 第一个单选框的change事件
    onChangeRadio1(e) {
      // console.log(e.target.value)
      this.separateMethod = e.target.value
      // console.log( this.separateMethod)
    },
    // 分单 提交
    reinsurancePolicy() {
      getSeparateList({ separateMethod: this.separateMethod, statementId: this.editList.majorStatementId }).then(
        res => {
          if (res.code === 0) {
            this.refreshEditList()
          } else {
            this.$message.error(res.msg)
          }
        }
      )
    },
    // 移除
    remove(record) {
      this.statementIds = ''
      this.removeible = true
      this.statementIds = record.orderId
      console.log(this.statementIds)
    },
    // 移除取消时调用的方法
    confirmCancel() {
      this.removeible = false
    },
    // 移除确定时调用的方法
    async confirmOk() {
      this.removeible = false
      this.removeLoading = false
      await removeList({ orderId: this.statementIds }).then(res => {
        if (res.code === 0) {
          this.refreshEditList()
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    handleAdd() {
      this.$refs.modal.add()
    },
    // 点按钮生成对账单
    handleremark(record) {
      this.$refs.modal.remark(record)
      console.log(record)
    }
  },
  watch: {}
}
</script>
<style scoped>
/deep/ .clickRowStyle {
  background: #d3d3d3;
}
/deep/ .clickRowStyleOrange {
  background: #ffbb77;
}
.editable-cell {
  position: relative;
}

.editable-cell-input-wrapper,
.editable-cell-text-wrapper {
  padding-right: 24px;
}

.editable-cell-text-wrapper {
  padding: 5px 24px 5px 5px;
}

.editable-cell-icon,
.editable-cell-icon-check {
  position: absolute;
  right: 0;
  width: 20px;
  cursor: pointer;
}

.editable-cell-icon {
  line-height: 18px;
  display: none;
}

.editable-cell-icon-check {
  line-height: 28px;
}

.editable-cell:hover .editable-cell-icon {
  display: inline-block;
}

.editable-cell-icon:hover,
.editable-cell-icon-check:hover {
  color: #108ee9;
}

.editable-add-btn {
  margin-bottom: 8px;
}
/deep/ .classYellow {
  background-color: #ffe168;
}
/deep/ .notshow {
  display: none;
}
/deep/ .ant-table th {
  white-space: nowrap;
}
/deep/ .ant-table td {
  white-space: nowrap;
  padding: 4px 16px;
}
</style>
